import {MasterOfActsAPI} from "../../api/api";
import {downloadFile} from "../../utils/files";

const SUCCESS_LOAD_ACTS = 'actReducer/SUCCESS_LOAD_ACTS'
const SUCCESS_LOAD_SELECTED_ACT = 'actReducer/SUCCESS_LOAD_SELECTED_ACT'
const ERROR_LOAD_SELECTED_ACT = 'actReducer/ERROR_LOAD_SELECTED_ACT'
const ERROR_LOAD_ACTS = 'actReducer/ERROR_LOAD_ACTS'
const SUCCESS_ADD_ACT = 'actReducer/SUCCESS_ADD_ACT'
const SUCCESS_PATCH_ACT = 'actReducer/SUCCESS_PATCH_ACT'
const REMOVE_ACTS = 'actReducer/REMOVE_ACTS'
const SET_LOADING = 'actReducer/SET_LOADING'
const SET_SELECTED_ACT = 'actReducer/SET_SELECTED_ACT';
const SET_SIGNATURE = 'actReducer/SET_SIGNATURE';
const COPY_ACT = 'actReducer/COPY_ACT'
const START_COPY_ACT = 'actReducer/START_COPY_ACT'
const COPY_ACT_NULL = 'actReducer/COPY_ACT_NULL';
const QR_HASH_SUCCESS = 'actReducer/QR_HASH_SUCCESS'
const VIOLATION_HASH_SUCCESS = 'actReducer/VIOLATION_HASH_SUCCESS'
const CLEAN_HASH_INFO = 'actReducer/CLEAN_HASH_INFO'
const CLEAN_VIOLATION_INFO = 'actReducer/CLEAN_VIOLATION_INFO'
const GET_ROWS_FOR_TABLE_CONSTRUCTOR = 'actReducer/GET_ROWS_FOR_TABLE_CONSTRUCTOR'

const initialState = {
    acts: [],
    hashObjData: null,
    violationHashData: null,
    selectedAct: null,
    copyAct: null,
    loading: false,
    loadingCopy: false,
    error: null,
    rowsForTableConstructor: null,
}

export const actReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {...state, loading: true}
        case SUCCESS_LOAD_ACTS:
            return {...state, acts: action.acts, loading: false, error: null}
        case SUCCESS_LOAD_SELECTED_ACT:
            return {...state, selectedAct: action.act, loading: false, error: null}
        case ERROR_LOAD_SELECTED_ACT:
            return {...state, loading: false, error: 'Выбранного акта не существует'}
        case ERROR_LOAD_ACTS:
            return {...state, loading: false, error: 'Что-то пошло не так...'}
        case SUCCESS_ADD_ACT:
            return {
                ...state, acts: [...state.acts, action.act],
                selectedAct: action.act,
                loading: false
            }
        case REMOVE_ACTS:
            return {
                ...state,
                acts: state.acts.filter(f => !(action.actIds.includes(f.id))),
                selectedAct: null,
                loading: false
            }
        case SET_SELECTED_ACT:
            return {...state, selectedAct: action.selectedAct}
        case SUCCESS_PATCH_ACT:
            return {
                ...state, acts: state.acts.map(act => {
                    if (act.id === action.act.id) {
                        return action.act
                    }
                    return act
                }),
                selectedAct: action.act,
                loading: false
            }
        case SET_SIGNATURE: 
            return {
                ...state,
                selectedAct: action.selectedAct,
            }
        case COPY_ACT: 
            return {
                ...state,
                copyAct: state.selectedAct,
                loadingCopy: false
            }
        case START_COPY_ACT: 
            return {
                ...state,
                loadingCopy: true
            }
        case COPY_ACT_NULL: 
            return {
                ...state,
                copyAct: null,
            }
        case QR_HASH_SUCCESS: 
            return {
                ...state,
                hashObjData: action.objAct,
            }
        case VIOLATION_HASH_SUCCESS: 
            return {
                ...state,
                violationHashData: action.objAct,
            }
        case CLEAN_HASH_INFO: 
            return {
                ...state,
                hashObjData: null,
                violationHashData: null,
            }
        case CLEAN_VIOLATION_INFO: 
            return {
                ...state,
                hashObjData: null,
                violationHashData: null,
            }
        case GET_ROWS_FOR_TABLE_CONSTRUCTOR:         
            return {
                ...state,
                rowsForTableConstructor: action.rows,
            }
        default:
            return state
    }
}

export const getActs = (state) => state.actReducer
export const getSelectedAct = state => state.actReducer.selectedAct
export const getCopyAct = state => state.actReducer.copyAct
export const getInfoCopyAct = state => state.actReducer.loadingCopy
export const getSelectedActId = state => state.actReducer.selectedAct.id
export const getQr = state => state.actReducer.selectedAct
export const getQrViolations = state => state.actReducer.selectedAct.violations
export const getInfoAct = state => state.actReducer.hashObjData
export const getInfoViolation = state => state.actReducer.violationHashData
export const getRowsForTableConstructor = state => state.actReducer.rowsForTableConstructor

const setLoading = () => ({type: SET_LOADING})
export const setRowsForTableConstructor = (rows) => ({type: GET_ROWS_FOR_TABLE_CONSTRUCTOR, rows})
export const copyAct = () => ({type: COPY_ACT})
export const successLoadActs = (acts) => ({type: SUCCESS_LOAD_ACTS, acts})
export const successLoadSelectedAct = act => ({type: SUCCESS_LOAD_SELECTED_ACT, act})
export const errorLoadActs = () => ({type: ERROR_LOAD_ACTS})
export const errorLoadSelectedAct = () => ({type: ERROR_LOAD_SELECTED_ACT})
export const successAddAct = (act) => ({type: SUCCESS_ADD_ACT, act})
export const successPatchAct = (act) => ({type: SUCCESS_PATCH_ACT, act})
export const removeActs = (actIds) => ({type: REMOVE_ACTS, actIds})
export const setSelectedAct = (selectedAct) => ({type: SET_SELECTED_ACT, selectedAct})
export const setSelectedSignature = (selectedAct) => ({type: SET_SIGNATURE, selectedAct})
export const startCopyAct = () => ({type: START_COPY_ACT})
export const copyActNull = () => ({type: COPY_ACT_NULL})
export const qrHashSuccess = (objAct) => ({type: QR_HASH_SUCCESS, objAct})
export const violationHashSuccess = (objAct) => ({type: VIOLATION_HASH_SUCCESS, objAct})
export const cleanHashinfo = () => ({type: CLEAN_HASH_INFO})
export const cleanHashViolation = () => ({type: CLEAN_VIOLATION_INFO})

export const copyActThunk = () => {
    return async (dispatch) => {
        // dispatch(startCopyAct())
        // dispatch(copyAct())
        dispatch(setSelectedAct(null))
      
    }
}



export const setSelectedSignatureThunk =  (selectedAct) => {
    return async (dispatch) => {
        dispatch(setSelectedSignature(selectedAct))
    }
}


export const loadViolations = async (violationIds) => {
    let violations = await Promise.all(violationIds.map(id => MasterOfActsAPI.getViolation(id)))
    violations = violations.map(el => el.data)
    return violations
}

export const getQrAct = (hash) => {
    return async (dispatch) => {
        const response = await MasterOfActsAPI.getActQr(hash)
        if (response.status === 200) {
            dispatch(qrHashSuccess(response.data))
        } else {console.log('error')}
    }
}

export const getViolation = (hash) => {
    return async (dispatch) => {
        const response = await MasterOfActsAPI.getViolationQR(hash)
        if (response.status === 200) {
            dispatch(violationHashSuccess(response.data))
        } else {console.log('error')}
    }
}

export const getActData = (id) => {
    return async (dispatch) => {
        const response = await MasterOfActsAPI.getActForViolation(id)
        if (response.status === 200) {
            dispatch(qrHashSuccess(response.data))
        } else {console.log('error')}
    }
}


const loadActFiles = async (actFilesId)  => {
    const responses = await Promise.all(actFilesId.map(id => MasterOfActsAPI.getActScan(id)))
    const allowedActFiles = []
    for (const response of responses) {
        if (response.status === 200) {
            allowedActFiles.push(response.data)
        }
    }
    return allowedActFiles
}

export const loadAct = (id) => async (dispatch) => {
    dispatch(setLoading())
    const response = await MasterOfActsAPI.getAct(id)
    if (response.status === 200) {
        const act = response.data
        act.violations = await loadViolations(act.violations)
        act.files = await loadActFiles(act.files)
        dispatch(successLoadSelectedAct(act))
    } else {
        dispatch(errorLoadSelectedAct())
    }
}

export const loadActs = project => async dispatch => {
    dispatch(setLoading())

    // const response = await MasterOfActsAPI.getActs(null, project)
    const response = await MasterOfActsAPI.getActsInfinite(null, project, { from: 0, size: 30 })
    if (response.status === 200) {
       
        const acts = response.data
        for (const act of acts) {
            let violationDescription = '';                
            for (const violation of act.content.tbl_contents) {
                violationDescription += violation.violationName+'\n';
            }
            act.violations = violationDescription;
       }        
        // for (const act of acts) {
        //     let violations = await loadViolations(act.violations)
        //     act.violations = violations.map(v => v.name)
        // }
        dispatch(successLoadActs(acts))
    } else {
        dispatch(errorLoadActs())
    }
}

export const patchAct = (id, {name, content, rawContent, status, comments, files, environmentStateId, creatorId, field_contractor, violations}) => async dispatch => {
    dispatch(setLoading())

    const response = await MasterOfActsAPI.saveAct(id,
        {
            name,
            content,
            rawContent,
            status,
            files,
            comments,
            environment_state: environmentStateId,
            creator: creatorId,
            field_contractor,
            violations,
        })

    if (response.status === 200) {
        const act = response.data
        let violations = await loadViolations(act.violations)
        console.log(violations.map(v => v.normative_article?.data?.short_text), 'violations.map(v => v.normative_article?.data?.short_text)')
        act.violations = violations.map(v => v.normative_article?.data?.short_text)
        dispatch(successPatchAct(act))
    } else {
        dispatch(errorLoadActs())
    }
}

export const patchActLock = (id, {name, content, rawContent, comments, files, environmentStateId, creatorId, violations}) => async dispatch => {
    dispatch(setLoading())

    const response = await MasterOfActsAPI.saveActLock(id,
        {
            name,
            content,
            rawContent,
            files,
            comments,
            environment_state: environmentStateId,
            creator: creatorId,
            violations
        })

    if (response.status === 200) {
        const act = response.data
        let violations = await loadViolations(act.violations)
        act.violations = violations.map(v => v.normative_article.data.short_text)
        dispatch(successPatchAct(act))
    } else {
        dispatch(errorLoadActs())
    }
}

export const createAct = ({name, content, rawContent, status, comments, files, environmentStateId, creatorId, field_contractor, violations}) => async dispatch => {
    dispatch(setLoading())
    const response = await MasterOfActsAPI.createAct({
        name,
        content,
        rawContent,
        status,
        files,
        comments,
        environment_state: environmentStateId,
        creator: creatorId,
        field_contractor,
        violations,
    })
    if (response.status === 201) {
        const act = response.data
        let violations = await loadViolations(act.violations)
        act.violations = violations.map(v => v.normative_article.data.short_text)
        dispatch(successAddAct(act))
    } else {
        dispatch(errorLoadActs())
    }
}

export const createActLock = ({name, content, rawContent, comments, files, environmentStateId, creatorId, violations}) => async dispatch => {
    dispatch(setLoading())
    const response = await MasterOfActsAPI.createActLock({
        name,
        content,
        rawContent,
        files,
        comments,
        environment_state: environmentStateId,
        creator: creatorId,
        violations
    })
    if (response.status === 201) {
        const act = response.data
        let violations = await loadViolations(act.violations)
        act.violations = violations.map(v => v.normative_article.data.short_text)
        dispatch(successAddAct(act))
    } else {
        dispatch(errorLoadActs())
    }
}

export const deleteActs = actIds => async dispatch => {
    dispatch(setLoading())
    const promiseResults = await Promise.allSettled(actIds.map(id => MasterOfActsAPI.deleteAct(id)))
    const succeeded = []
    for (const [index, promiseResult] of promiseResults.entries()) {
        if (promiseResult.status === 'fulfilled') {
            succeeded.push(actIds[index])
        }
    }
    dispatch(removeActs(succeeded))
}

export const signedActFile = async (actId) => {
    const response = await MasterOfActsAPI.signedActFileDoc(actId)
}

//-------СТАРАЯ ТЕХНОЛОГИЯ---------
export const downloadActFile = async (actId) => {
   
   const response = await MasterOfActsAPI.downloadActFileDoc(actId)
 
    if (response.status === 200){                                                      
        await downloadFile(MasterOfActsAPI.downloadActFileDoc(actId)) 
    } else {    
        await downloadFile(MasterOfActsAPI.downloadActExcelFileDoc(actId))
    }
}
//-------СТАРАЯ ТЕХНОЛОГИЯ---------

export const downloadActWordFile = async (actId) => {

    await downloadFile(MasterOfActsAPI.downloadActFileDoc(actId))

}

export const downloadActExcelFile = async (actId) => {

    await downloadFile(MasterOfActsAPI.downloadActExcelFileDoc(actId))

}

export const downloadViolationFile = async (fileId) => {
    await downloadFile(MasterOfActsAPI.downloadViolationFile(fileId))
}

export const downloadActScanFile = async (fileId) => {
    await downloadFile(MasterOfActsAPI.downloadActScanFile(fileId))
}

export const downloadActFileHash =  (actId) => {
    return async (dispatch) => {
        const response = await MasterOfActsAPI.downloadActFileDoc(actId)

        if (response.status === 200) {
            dispatch(cleanHashinfo())
        }
    }
}
